import {
  HTTP_INTERCEPTORS,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { StorageKeys } from 'src/app/configs/storage-keys-config';

@Injectable()
export class ActiveOrganizationInterceptor implements HttpInterceptor {

  intercept(
    httpRequest: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    //read from local storage

    const organizationId = +localStorage.getItem(
      StorageKeys.activeOrganizationId
    );

    //set header
    if (organizationId)
      httpRequest = httpRequest.clone({
        headers: httpRequest.headers.set('c-org-id', organizationId.toString()),
      });

    return next.handle(httpRequest).pipe(
      catchError((err) => throwError(() => err))
    );
  }
}

export const HttpActiveOrganizationInterceptor = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ActiveOrganizationInterceptor,
    multi: true,
  },
];
